module.exports = __webpack_public_path__ + "static/tgi-f037767cd0786627e6ce57aee7bd8217.png";